/** Where a lapsed session sends the browser: the login screen, told why and
 *  where to come back to. */
export function loginUrlFor(path: string): string {
  const qs = new URLSearchParams({ expired: '1' })
  if (path && path !== '/') qs.set('next', path)
  return `/login?${qs}`
}

/** The place to return to after login. Only a path on this console counts —
 *  never another site, never the login screen itself. */
export function safeNext(next: string | null | undefined): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return '/'
  if (next === '/login' || next.startsWith('/login?') || next.startsWith('/login/')) return '/'
  return next
}
